import { render } from "./PagesLayout.vue?vue&type=template&id=5a40489a&scoped=true&ts=true"
import script from "./PagesLayout.vue?vue&type=script&lang=ts"
export * from "./PagesLayout.vue?vue&type=script&lang=ts"

import "./PagesLayout.vue?vue&type=style&index=0&id=5a40489a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a40489a"]])

export default __exports__